import React from 'react';
import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import defaultStyles from './button.scss';

enum ElementName {
    a = 'a',
    button = 'button',
}

interface Props {
    children: React.ReactNode;
    styles: typeof defaultStyles;
    src?: string;
}


class Base extends React.PureComponent<Props & { elementName: ElementName }> {
    render() {
        const { styles, children, src, elementName, ...rest } = this.props;

        return React.createElement(
            elementName,
            { ...rest, className: styles.button },
            <span className={styles.container}>
                {src ? <SVGIcon style={{image: styles.icon}}  src={src} /> : null}
                {children}
            </span>
        );
    }
}

type ButtonProps = Props & React.ButtonHTMLAttributes<HTMLButtonElement>;
type AnchorProps = Props & React.AnchorHTMLAttributes<HTMLAnchorElement>;

function Button(props: ButtonProps) {
    return <Base elementName={ElementName.button} {...props} />;
}
function Anchor(props: AnchorProps) {
    return <Base elementName={ElementName.a} {...props} />;
}

const StyledAnchor = Styled(defaultStyles)(Anchor as React.StatelessComponent<AnchorProps>);

export { StyledAnchor as Anchor };
export default Styled(defaultStyles)(Button as React.StatelessComponent<ButtonProps>);
